import React from 'react';
import {hashHistory} from 'react-router';
import PropTypes from 'prop-types';
import Header from './common/Header';
import Footer from './common/Footer';
import Tabs from './common/Tabs';
import {observer, inject} from 'mobx-react';
import {AppBar, Drawer, FloatingActionButton, IconButton} from 'material-ui';
import SoundOn from 'material-ui/svg-icons/social/notifications-active';
import SoundOff from 'material-ui/svg-icons/social/notifications-off';
import Menu from 'material-ui/svg-icons/navigation/menu';
import Home from 'material-ui/svg-icons/action/home';
import $ from 'jquery';
import {Alarm} from './Watch/Alarm';

@inject('markerStore', 'contentStore')
@observer
class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mobView: $(window).width() <= 1000,
      open: false,
      appHeader: 'Flood Forecasting Section',
      pause: false
    }
  }

  playPause = () => this.setState({pause: !this.state.pause});

  componentWillMount() {
    window.addEventListener("resize", this.adaptView);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.adaptView);
    this.props.markerStore.socketDisconnect();
    this.props.contentStore.socketDisconnect();
  }

  adaptView = () => {
    let mobView = $(window).width() <= 1000;
    if (mobView !== this.state.mobView) {
      this.setState({mobView: mobView});
    }
  };
  toggleOpen = () => this.setState({open: !this.state.open});
  onChangeTab = (tab) => this.setState({appHeader: tab});

  render() {
    let {markerStore:{getCombinedAlert}, contentStore: {alerts}} = this.props;
    let floatingButtonStyle = {position: 'fixed', right: '20px', bottom: '20px', zIndex: '3000'};

    if (this.state.mobView) {
      return (
        <div className="full-height">
          <div className='myContainer'>
            <AppBar
              title={this.state.appHeader}
              iconElementLeft={<div>
                <IconButton iconStyle={{color: 'white'}} onClick={this.toggleOpen}><Menu/></IconButton>
                <IconButton iconStyle={{color: 'white'}} onClick={() => hashHistory.replace('/')}><Home/></IconButton>
              </div>}
            />
            {alerts.length > 0 && <div className="marquee"><p>!!! {alerts.map(item => item.message).join(' | ')} !!!</p></div>}
            <Drawer open={this.state.open} containerStyle={{width: '250px', zIndex: 3000}} docked={false}
                    onRequestChange={this.toggleOpen}>
              <Header mobView={this.state.mobView}/>
              <Tabs mobView={this.state.mobView} toogleOpen={this.toggleOpen} onChangeTab={this.onChangeTab}/>
            </Drawer>
            <main>
              {this.props.children ? React.cloneElement(this.props.children, {mobView: true}) : null}
            </main>
          </div>
          <Footer mobView/>
          {getCombinedAlert.play && !this.state.pause && <Alarm hidden={false}/>}
          {getCombinedAlert.play && <FloatingActionButton zDepth={2} backgroundColor={getCombinedAlert.color} style={floatingButtonStyle} onClick={this.playPause} className={this.state.pause?'':'alert-bell'}>
            {this.state.pause ? <SoundOff className="zoom-in"/> : <SoundOn className='zoom-in '/>}
            </FloatingActionButton>}
        </div>
      );
    } else {
      return (
        <div className="full-height">
          <div className="myContainer">
            <Header/>
            <Tabs/>
            {alerts.length > 0 && <div className="marquee"><p>!!! {alerts.map(item => item.message).join(' | ')} !!!</p></div>}
            <main>
              {this.props.children}
            </main>
          </div>
          <Footer/>
          {getCombinedAlert.play && !this.state.pause && <Alarm hidden={true}/>}
          {getCombinedAlert.play &&
          <FloatingActionButton
            zDepth={2}
            backgroundColor={getCombinedAlert.color}
            style={floatingButtonStyle}
            onClick={this.playPause}
            className={this.state.pause?'':'alert-bell'}
          >
            {this.state.pause ? <SoundOff className="zoom-in"/> : <SoundOn className='zoom-in '/>}
          </FloatingActionButton>}
        </div>
      );
    }
  }
}

App.propTypes = {
  children: PropTypes.object.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js